/*
 * Site-wide quote cart (docs/quote-only-ordering-spec.md).
 * Deliberately localStorage-based, NOT the Shopify cart: quote-only variants
 * can't enter the cart (inventory 0 + DENY), and mixing quote and buy lines
 * would confuse checkout. Submission happens via the contact form on the
 * quote page (sections/dm-quote-cart.liquid).
 */
(function () {
  'use strict';

  var KEY = 'dm_quote_cart_v1';
  var MAX_ITEMS = 50;

  function read() {
    try {
      var raw = JSON.parse(localStorage.getItem(KEY));
      return Array.isArray(raw) ? raw : [];
    } catch (e) {
      return [];
    }
  }

  function write(items) {
    try {
      localStorage.setItem(KEY, JSON.stringify(items.slice(0, MAX_ITEMS)));
    } catch (e) {
      /* storage full/blocked — quote cart degrades to no-op */
    }
    updateBubbles(items);
    document.dispatchEvent(new CustomEvent('dm:quote:change', { detail: { items: items } }));
  }

  function count(items) {
    return items.reduce(function (n, i) {
      return n + (parseInt(i.qty, 10) || 1);
    }, 0);
  }

  function updateBubbles(items) {
    var n = count(items || read());
    document.querySelectorAll('[data-dm-quote-bubble]').forEach(function (bubble) {
      bubble.hidden = n === 0;
      var num = bubble.querySelector('[data-dm-quote-count]');
      if (num) num.textContent = n < 100 ? String(n) : '99+';
    });
    // "View quote list →" links (under Add to Quote buttons) show once the
    // list has anything in it.
    document.querySelectorAll('[data-dm-quote-view]').forEach(function (link) {
      link.hidden = n === 0;
    });
  }

  function itemKey(item) {
    if (item.custom) return item.key;
    return item.variantId || item.sku || item.handle;
  }

  function add(item) {
    var items = read();
    var key = itemKey(item);
    var existing = items.find(function (i) {
      return itemKey(i) === key;
    });
    if (existing) {
      existing.qty = (parseInt(existing.qty, 10) || 1) + (parseInt(item.qty, 10) || 1);
    } else {
      /* Multi-variant products (variantTitle set) get ?variant= on the stored
         URL so quote click-throughs open the exact variant quoted. */
      var url = item.url || '';
      if (url && item.variantId && item.variantTitle && url.indexOf('variant=') === -1) {
        url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + item.variantId;
      }
      items.push({
        handle: item.handle,
        url: url,
        title: item.title,
        vendor: item.vendor || '',
        sku: item.sku || '',
        variantId: item.variantId || '',
        variantTitle: item.variantTitle || '',
        image: item.image || '',
        qty: parseInt(item.qty, 10) || 1,
      });
    }
    write(items);
  }

  /* Free-form line for parts we don't list: name + optional link/MPN and
     the price the customer wants beaten (price-match tie-in). */
  function addCustom(item) {
    if (!item.title) return;
    var items = read();
    items.push({
      custom: true,
      key: 'c:' + Date.now() + ':' + Math.random().toString(36).slice(2, 7),
      title: item.title,
      link: item.link || '',
      qty: parseInt(item.qty, 10) || 1,
      priceToBeat: item.priceToBeat || '',
    });
    write(items);
  }

  function setField(key, field, value) {
    var items = read();
    var item = items.find(function (i) {
      return itemKey(i) === key;
    });
    if (item) {
      item[field] = value;
      write(items);
    }
  }

  function remove(key) {
    write(
      read().filter(function (i) {
        return itemKey(i) !== key;
      })
    );
  }

  function setQty(key, qty) {
    qty = parseInt(qty, 10);
    if (!qty || qty < 1) return remove(key);
    var items = read();
    var item = items.find(function (i) {
      return itemKey(i) === key;
    });
    if (item) {
      item.qty = qty;
      write(items);
    }
  }

  function clear() {
    write([]);
  }

  /* Resolve the currently-selected variant for a PDP add button: prefer the
     product form's live `name="id"` input, then the ?variant= URL param, and
     fall back to the button's server-rendered default. */
  function resolveVariant(button) {
    var result = {
      variantId: button.dataset.variantId || '',
      sku: button.dataset.sku || '',
      variantTitle: '',
    };
    var mapEl = document.querySelector(
      'script[data-dm-variant-map][data-handle="' + button.dataset.handle + '"]'
    );
    if (!mapEl) return result;

    var map;
    try {
      map = JSON.parse(mapEl.textContent);
    } catch (e) {
      return result;
    }

    /* Find the selected variant id, validating every candidate against THIS
       product's map — quote-only PDPs have no product form, and a
       document-wide query could grab a recommendation card's form for a
       different product entirely. Fall back to the button's server-rendered
       default, which still gets its title/sku filled from the map. */
    var currentId = '';
    var scope = button.closest('.shopify-section') || document;
    var input = scope.querySelector('input.product-variant-id');
    if (input && input.value && map[input.value]) currentId = input.value;
    if (!currentId) {
      var urlId = new URLSearchParams(window.location.search).get('variant') || '';
      if (map[urlId]) currentId = urlId;
    }
    if (!currentId) currentId = result.variantId;

    var entry = map[currentId];
    if (entry) {
      result.variantId = currentId;
      result.sku = entry.sku || result.sku;
      if (entry.title && entry.title !== 'Default Title') result.variantTitle = entry.title;
    }
    return result;
  }

  function resolveQty(button) {
    var sectionId = button.dataset.sectionId;
    var input = sectionId && document.getElementById('Quantity-' + sectionId);
    return (input && parseInt(input.value, 10)) || 1;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-dm-quote-add]');
    if (!button) return;
    event.preventDefault();

    var variant = resolveVariant(button);
    add({
      handle: button.dataset.handle,
      url: button.dataset.url,
      title: button.dataset.title,
      vendor: button.dataset.vendor,
      image: button.dataset.image,
      qty: resolveQty(button),
      variantId: variant.variantId,
      sku: variant.sku,
      variantTitle: variant.variantTitle,
    });

    var label = button.querySelector('.dm-quote-add__label');
    var done = button.querySelector('.dm-quote-add__done');
    if (label && done) {
      label.hidden = true;
      done.hidden = false;
      window.setTimeout(function () {
        label.hidden = false;
        done.hidden = true;
      }, 2000);
    }
  });

  /* PDP "found it cheaper?" price-match link: put the product on the quote
     list (unless it's already there — don't bump qty on a repeat click), then
     follow the link with ?pm=<key> so the quote page can focus that item's
     price-to-beat field. No JS → plain link to the quote page. */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-dm-quote-price-match]');
    if (!link) return;
    event.preventDefault();

    var variant = resolveVariant(link);
    var item = {
      handle: link.dataset.handle,
      url: link.dataset.url,
      title: link.dataset.title,
      vendor: link.dataset.vendor,
      image: link.dataset.image,
      qty: resolveQty(link),
      variantId: variant.variantId,
      sku: variant.sku,
      variantTitle: variant.variantTitle,
    };
    var key = itemKey(item);
    var exists = read().some(function (i) {
      return itemKey(i) === key;
    });
    if (!exists) add(item);

    var url = new URL(link.href, window.location.origin);
    url.searchParams.set('pm', key);
    window.location.assign(url.toString());
  });

  window.DMQuoteCart = {
    read: read,
    add: add,
    addCustom: addCustom,
    setField: setField,
    remove: remove,
    setQty: setQty,
    clear: clear,
    count: function () {
      return count(read());
    },
    itemKey: itemKey,
  };

  /* Cart guard: Shopify's cart/add accepts unavailable variants (checkout is
     where DENY actually blocks), so a crafted /cart/add?id= permalink can put
     a $0.00 quote-only line in the cart. Liquid (dm-quote-only-cart-lines)
     emits any such lines; we move them to the quote list, drop them from the
     cart, and reload so every cart render is consistent. */
  function sweepQuoteOnlyCartLines() {
    var el = document.querySelector('[data-dm-quote-only-lines]');
    if (!el) return;
    var lines;
    try {
      lines = JSON.parse(el.textContent);
    } catch (e) {
      return;
    }
    if (!lines.length) return;

    var sweptKey = 'dm_quote_swept';
    var swept;
    try {
      swept = JSON.parse(sessionStorage.getItem(sweptKey)) || [];
    } catch (e) {
      swept = [];
    }

    var updates = {};
    lines.forEach(function (line) {
      updates[line.key] = 0;
      if (swept.indexOf(line.key) !== -1) return; // removal retry — don't double-add
      add({
        handle: line.handle,
        url: line.url,
        title: line.title,
        vendor: line.vendor,
        sku: line.sku,
        variantId: line.variantId,
        variantTitle: line.variantTitle === 'Default Title' ? '' : line.variantTitle,
        image: line.image,
        qty: line.qty,
      });
      swept.push(line.key);
    });
    try {
      sessionStorage.setItem(sweptKey, JSON.stringify(swept.slice(-50)));
      sessionStorage.setItem('dm_quote_sweep_notice', '1');
    } catch (e) {
      /* ignore */
    }

    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates }),
    })
      .then(function () {
        window.location.reload();
      })
      .catch(function () {
        /* leave the line; checkout still blocks it */
      });
  }

  function showSweepNotice() {
    var flag;
    try {
      flag = sessionStorage.getItem('dm_quote_sweep_notice');
      sessionStorage.removeItem('dm_quote_sweep_notice');
    } catch (e) {
      return;
    }
    if (!flag) return;
    var toast = document.createElement('div');
    toast.className = 'dm-quote-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = 'That item is quote-only — we moved it to your quote list.';
    var link = document.createElement('a');
    link.href = '/pages/quote-list';
    link.textContent = 'View quote list →';
    toast.appendChild(link);
    document.body.appendChild(toast);
    window.setTimeout(function () {
      toast.remove();
    }, 8000);
  }

  function init() {
    updateBubbles(read());
    showSweepNotice();
    sweepQuoteOnlyCartLines();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

